import { Outlet } from 'react-router-dom';
import { FooterComponent } from './footer.component';
import { MainNavigationPanel } from './main-navigation-panel.component';
import DuxWidget from './dux_widget';
import { IconButton, Tooltip } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useState } from 'react';
import { isMobile } from 'react-device-detect';

const isDUXEnabled = process.env.REACT_APP_DUX_FLAG === 'true';
const isMobileViewEnabled = process.env.REACT_APP_MOBILE_VIEW_FLAG === 'true';

export const RootLayout = () => {
  const [toggleValue, setToggleValue] = useState<any>(false);
  return (
    <>
      <div className={toggleValue ? 'contentOuterWrapper mobOuter' : 'contentOuterWrapper '}>
        <div className={` ${(isMobile && isMobileViewEnabled) ? 'mobShow burgerMenu' : 'mobHidden'}`}>
          <IconButton className="btn btn-goBack" aria-label="back" onClick={() => setToggleValue(!toggleValue)}>
            <Tooltip title={'Menu'}>
              <MenuIcon />
            </Tooltip>
          </IconButton>
        </div>

        <MainNavigationPanel />

        <Outlet />
      </div>
      <FooterComponent />
      {isDUXEnabled ? <DuxWidget /> : null}
      {/* </div> */}
    </>
  );
};
